export const MAP_DEFAULTS = {
  viewport: {
    latitude: 40.7450,
    longitude: -123.8695,
    zoom: 8,
  }
};